import repository from './repsitory'

const resource = '/gameRarity'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getByGame (id) {
        return repository.get(`${resource}/getbygame/${id}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    addGameRarity (data) {
        return repository.post(`${resource}`, data)
    },
    updateGameRarity (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
}
